export default __webpack_public_path__ + "static/media/logo-dark-ibiza.cbf94079.png";